import React from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'

import NavigationGroupLink from './NavigationGroupLink'
import { NavigationGroupLink as NavigationGroupLinkType } from '../../types/page'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { useTranslation } from 'gatsby-plugin-react-i18next'

interface Props {
  phoneProps: NavigationGroupLinkType
  phoneClass?: string
  variant?: string
}

const NavigationGroupPhone: React.FC<Props> = ({
  phoneProps,
  phoneClass,
  variant,
}) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Container
      className={clsx({
        [classes.container]: true,
        //@ts-ignore
        [phoneClass]: phoneClass,
        [classes.containerRichText]: variant === 'richText',
      })}
      disableGutters
    >
      <FiberManualRecordIcon className={classes.icon} />
      <Container className={classes.textContainer} disableGutters>
        {variant !== 'richText' && (
          <Typography className={classes.text}>
            {t('navigation.call')}
          </Typography>
        )}
        <NavigationGroupLink link={phoneProps} />
      </Container>
    </Container>
  )
}

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      alignItems: 'center',
      display: 'flex',
      margin: 'unset',
      width: 'auto',
      [theme.breakpoints.down('sm')]: {
        backgroundColor: theme.palette.primary.light,
        borderTop: `1px solid ${theme.colors.cyan[300]}`,
        borderBottom: `1px solid ${theme.colors.cyan[300]}`,
        flexDirection: 'row-reverse',
        justifyContent: 'space-between',
        padding: '1.25em 6% 1.25em 6%',
        width: '100%',
      },
    },
    containerRichText: {
      [theme.breakpoints.down('sm')]: {
        backgroundColor: 'unset',
        border: 'none',
        flexDirection: 'row',
        padding: '0',
        width: 'auto',
      },
    },
    icon: {
      color: theme.palette.success.main,
      fontSize: '1em',
      marginRight: '.5em',
    },
    text: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'unset',
        marginRight: '.5em',
      },
    },
    textContainer: {
      color: theme.colors.cyan[400],
      margin: '0',
      width: 'unset',

      '& a': {
        color: 'inherit',
      },
    },
  })
)

export default NavigationGroupPhone
